import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { NgWizardService } from 'ng-wizard';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';
import { ExportExcelService } from 'src/app/shared/xlsx-view/export-excel.service';

@Component({
  selector: 'app-whitelist-content-and-learing',
  templateUrl: './whitelist-content-and-learing.component.html',
  styleUrls: ['./whitelist-content-and-learing.component.scss']
})
export class WhitelistContentAndLearingComponent implements OnInit {
  @Input() engagementId = "";
  @Input() engagementType = "";
  @Input() whitelistObj = {};
  @Input() zoneData:any =[];

  @Output() whiteListed: EventEmitter<boolean> = new EventEmitter;
 
  whitelistUser : any = [];
  getPaginationCount;
  page = 1;

  excelFormat: any = {};
  excelArray: any = [];
  excelData: any = [];
  commonSearch : any = "";
  subTaskId:any = "";
  // regionData:any =[];
  // stateData:any = [];
  // cityData:any = [];
  zoneId:any ="" 
  localData: any;
  constructor(
    private router: Router,
    private exportExcelService: ExportExcelService,
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private toast : ToastClientService
  ) { 
    this.localData = JSON.parse(localStorage.getItem('engagementDetail'))
    this.zoneId = this.localData.zone_id != null ? this.localData.zone_id : ""
  }

  ngOnInit() {
    this.fetchZoneTypeData(this.localData.zone_type)
    if(this.engagementId && this.engagementType){
      this.getWhitelistUser();
    }
  }
  ngOnChanges(){
    console.log(this.engagementId)
    console.log(this.engagementType)
    this.localData = JSON.parse(localStorage.getItem('engagementDetail'))
    this.zoneId = this.localData.zone_id != null ? this.localData.zone_id : ""
  }
  uploadExcel(){
    this.router.navigate(["/hubAdmin/content-and-learnings-excel-upload/"+this.engagementId + "/" + this.engagementType])
  }

  filter(){
    this.getWhitelistUser()
  }
  reset(){
    this.commonSearch = ''
    this.getWhitelistUser()
  }

  getZoneId(e){
    // console.log(e.target.value);
    this.zoneId = e.target.value
  }

  zonebasedWhitelist(){
    console.log(this.localData);
    
    let payload = {
      has_subtask : this.localData.has_subtask,
      sub_tasks_id: this.subTaskId,
      engagement_type : this.engagementType,
      engagement_type_id: this.localData.engagement_type_id,
      task_id: this.localData.task_id,
      whitelist_type : this.localData.whitelist_type,
      zone_type : this.localData.zone_type,
      zone_id : this.zoneId
    }

    this.apiService.post(this.apiConfig.whiteListEngagementUser, payload).subscribe((res)=>{
      if(res.status == 200){
        this.toast.Success(res.body.data.message)
        this.router.navigate(["/hubAdmin/content-and-learnings"])
      }
    })
  }

  fetchZoneTypeData(zone_type){
    if(zone_type==1){
      this.apiService.get(this.apiConfig.configGetRegion).subscribe((res)=>{
        this.zoneData = res['data'].region
        console.log("regionData",this.zoneData);
      })
    }else if(zone_type==2){
      this.apiService.get(this.apiConfig.configGetStates).subscribe((res)=>{
        this.zoneData = res['data'].state;
        console.log("SateData",this.zoneData);
      })
    }else{
      this.apiService.get(this.apiConfig.configGetCities).subscribe((res)=>{
        this.zoneData = res['data'].cities;
        console.log("cityData",this.zoneData);
      })
    }
}


  getWhitelistUser(){
    this.excelArray = [];
    this.excelData = [];
    this.apiService.getHeaders(this.apiConfig.engagemetnWhitelistUser + `?engagement_page=3&engagement_type=${this.engagementType}&task_id=${this.engagementId}&search=${this.commonSearch}`).subscribe((res : any)=>{
      console.log(res)
      this.whitelistUser = res.body.data.data;
      //2) for excelData
      this.excelData = res.body.data.full_data;
 
    })
  }

  DownloadReportExcel() {
    this.exportExcelService.DownloadReportExcel('Point_configuration', this.excelData, this.excelArray);
  }

  paginationClick(e) {
    console.log(e);
    this.page = e;
    this.getWhitelistUser();
  }

  submit(){
   this.whiteListed.emit(true)
  }

  toggleStatus(user){
    console.log(this.whitelistUser);
    console.log(user);
    
    let payload = {
      engagement_id: this.localData.engagement_type_id,
      id: user.id,
      status : user.status == 0 ? 1 : 0
    }
    this.apiService.post(this.apiConfig.disableEngagement,payload).subscribe((res : any)=>{
      if(res.status ==200){
        this.toast.Success(res.body.data)
      }else{
        this.toast.Error(res.body.data)
      }
      this.getWhitelistUser();
    })
  }
}
